/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./no-order.vue.js?vue&type=template&id=a34b0b22&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./no-order.vue?vue&type=template&id=a34b0b22&scoped=true"
import script from "./no-order.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./no-order.vue?vue&type=script&setup=true&lang=js"
export * from "./no-order.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./no-order.vue?vue&type=script&setup=true&lang=js"
import style0 from "./no-order.vue.postcss?vue&type=style&index=0&id=a34b0b22&prod&lang=postcss&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./no-order.vue?vue&type=style&index=0&id=a34b0b22&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34b0b22",
  null
  
)

export default component.exports